module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS4xMiAyMS4xMiI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdkIiBkPSJNMTEuNDYuNWwyLjI4MywxMy4zMjdMLjUsMTEuNDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEwKSByb3RhdGUoLTQ1KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/common/SendTriangle.svg
// module id = 315
// module chunks = 1